// extracted by mini-css-extract-plugin
export default {"hoverPreview":"TableStyleSettings_hoverPreview__vmdI+","hoverPreviewHead":"TableStyleSettings_hoverPreviewHead__2E9L9","hoverPreviewRow":"TableStyleSettings_hoverPreviewRow__GN2mh"};